import { Dashboard } from 'components/pages/dashboard'
import { ReactElement } from 'react'

const DashboardPage = (): ReactElement => <Dashboard />

export default DashboardPage
